export default __webpack_public_path__ + "static/media/favicon.d66e0ce1.ico";